import { createSelector, OutputParametricSelector } from 'reselect';

import { RepositoryIdValue } from 'yeself-common/typings/addons/assetAddon/AssetAddonCommon';
import { LayerNodeId } from 'yeself-common/typings/guide/LayerCommon';
import {
    AddonSystemKeyValue,
    AssetId,
    RecordAsset,
} from 'yeself-common/typings/guide/recording/Recording';

import { makeSelectGraphMetadata } from '../selectors';

export const makeSelectOutputAssetsArray = (): OutputParametricSelector<
    any,
    LayerNodeId,
    RecordAsset[],
    (res: RecordAsset[]) => RecordAsset[]
> => createSelector([makeSelectGraphMetadata()], ({ outputAssets = [] }) => outputAssets);

export const makeSelectOutputAssets = () =>
    createSelector([makeSelectGraphMetadata()], ({ outputAssets = [] }) =>
        outputAssets.length > 0 ? outputAssets[0] : outputAssets
    );

export const makeSelectOutputAssetsLink = () =>
    createSelector([makeSelectOutputAssets()], ({ link = {} }) => link);

export const makeSelectOutputAssetId = (): OutputParametricSelector<
    any,
    LayerNodeId,
    AssetId,
    (res: AssetId) => AssetId
> => createSelector([makeSelectOutputAssetsLink()], ({ id = '' }) => id);

export const makeSelectOutputAssetAddonSystemKey = (): OutputParametricSelector<
    any,
    LayerNodeId,
    AddonSystemKeyValue,
    (res: AddonSystemKeyValue) => AddonSystemKeyValue
> => createSelector([makeSelectOutputAssetsLink()], ({ addonSystemKey = '' }) => addonSystemKey);

export const makeSelectOutputAssetRepositoryId = (): OutputParametricSelector<
    any,
    LayerNodeId,
    RepositoryIdValue,
    (res: RepositoryIdValue) => RepositoryIdValue
> => createSelector([makeSelectOutputAssetsLink()], ({ repositoryId = '' }) => repositoryId);
